// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CostStatementEffortDetail  {
    _originalTypeClassName = "Loom.BO.CostStatementEffortDetail";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CostStatementEffortDetail.translate = translateService;
}
this.Id = null;
this.GATotalPMs = null;
this.LinearProjectionPMsInclPeriod = null;
this.ReportedPMsUntilPeriodStart = null;
this.PeriodPMsForA123Actuals = null;
this.PeriodPMsForA123UnitCosts = null;
this.PeriodPMsForA4UnitCosts = null;
this.DeviationJustification = null;
this.TotalReportedPMs = null;
this.TotalReportedPMsInclPeriod = null;
this.TotalPMDeviationFromGA = null;
this.PreviousDeviationJustifications = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
GATotalPMs:any;
LinearProjectionPMsInclPeriod:any;
ReportedPMsUntilPeriodStart:any;
PeriodPMsForA123Actuals:any;
PeriodPMsForA123UnitCosts:any;
PeriodPMsForA4UnitCosts:any;
DeviationJustification:any;
TotalReportedPMs:any;
TotalReportedPMsInclPeriod:any;
TotalPMDeviationFromGA:any;
PreviousDeviationJustifications:any;
WorkPackage:any;
CostStatement:any;
static setWorkPackage = ($this, value) => {
var oldValue = $this.WorkPackage;
$this.WorkPackage = value;
if (value != null) {
}
}
static setCostStatement = ($this, value) => {
var oldValue = $this.CostStatement;
$this.CostStatement = value;
if (value != null) {
if (oldValue != null) {
Domain.CostStatement.removeCostStatementEffortDetails(oldValue, $this);
}
Domain.CostStatement.addCostStatementEffortDetails(value, $this);
}
}

static GetTotalPMDeviationFromGA($this: any): any{if ((CLMS.Framework.Number.LessThanOrEqual(() => $this.LinearProjectionPMsInclPeriod, () => 0))) {return (CLMS.Framework.Number.LessThanOrEqual(() => Domain.CostStatementEffortDetail.GetTotalReportedPMsInclPeriod($this), () => 0) ? 0 : 1);}
let deviationPercentage = Math.abs(Joove.Common.safeNumber((Joove.Common.safeNumber(Domain.CostStatementEffortDetail.GetTotalReportedPMsInclPeriod($this)) - Joove.Common.safeNumber($this?.LinearProjectionPMsInclPeriod))) / Joove.Common.safeNumber($this?.LinearProjectionPMsInclPeriod));
return Joove.Common.mathRound(deviationPercentage, 2);
}
static GetTotalReportedPMs($this: any): any{return Joove.Common.safeNumber($this?.PeriodPMsForA123Actuals) + Joove.Common.safeNumber($this?.PeriodPMsForA123UnitCosts) + Joove.Common.safeNumber($this?.PeriodPMsForA4UnitCosts);
}
static GetTotalReportedPMsInclPeriod($this: any): any{return Joove.Common.safeNumber($this?.ReportedPMsUntilPeriodStart) + Joove.Common.safeNumber($this?.PeriodPMsForA123Actuals) + Joove.Common.safeNumber($this?.PeriodPMsForA123UnitCosts) + Joove.Common.safeNumber($this?.PeriodPMsForA4UnitCosts);
}
static IsCostsDeviationJustificationRequired($this: any): any{if (CLMS.Framework.Number.LessThanOrEqual(() => $this.LinearProjectionPMsInclPeriod, () => 0)) {return false;}
if (!(CLMS.Framework.String.IsNullOrEmpty(($this?.DeviationJustification ?? '').trim()))) {return false;}
return CLMS.Framework.Number.GreaterThan(() => Joove.Common.safeNumber(Math.abs(Joove.Common.safeNumber($this.TotalReportedPMsInclPeriod) - Joove.Common.safeNumber($this.LinearProjectionPMsInclPeriod))) / Joove.Common.safeNumber($this.LinearProjectionPMsInclPeriod), () => 0.15);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}